import { z } from 'zod';

export const AllowedListValidationBlockSchema = z.array(z.unknown());
export type AllowedListValidationBlock = z.infer<
  typeof AllowedListValidationBlockSchema
>;

type IsAllowedList = (
  value: unknown,
  block: AllowedListValidationBlock
) => boolean;
export const isAllowedList: IsAllowedList = (value, block) => {
  if (!Array.isArray(block)) {
    return false;
  }

  return block.includes(value);
};
